import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch} from 'react-redux';
import { Divider, Loader, Modal, Button } from 'rsuite';
import moment from 'moment';
import 'moment/locale/bg';  // without this line it didn't work
import * as actionsPolicy  from '../../../../app/actions/policy';
import * as actionsUser  from '../../../../app/actions/user';
import {getRegValues, countDaysPastDueDate, findLastPaidOrConDCashFlow, isPolicyExpired, isPolicyAdded, isBeforeFirstCashflow, 
    daysToFirstCashFlow, findOtherActivePolicy, isOtherActivePolicyStopsNew, sortPoliciesByContractDate} from '../../../../app/common/services/vehicle.service';
import {BackIcon} from '../../../pages/components/svg/iconsSvg';
import InsCompLogos from '../../../pages/components/svg/insCompLogos';
import {insCompBgNames} from '../../../../app/common/types/insCompTypes';

const MyPolicyList = ({onForward, style}) => {

    const history = useHistory();

    const dispatch = useDispatch();

    const {loginToken} = useSelector(state => state.auth) || {};
    const {myPolicies} = useSelector(state=>state.userDetails);

    const [loading, setLoading] = useState(false);

    const [confirmModal, setConfirmModal] = useState({open:false, insuranceId: null});

//console.log(myPolicies)
    useEffect(()=>{
        if(myPolicies) {
            myPolicies.sort(sortPoliciesByContractDate);
        }
    }, [myPolicies]);

    useEffect(()=>{
        if(!loginToken) {
            history.push('/app/profile');
        }
    }, [loginToken, history]);

    // useEffect(()=>{
    //     const fetchPolicies = async () => {
    //         setLoading(true);
    //         await dispatch(actionsUser.getMyPolicies());
    //         setLoading(false);
    //     }
    //     if(!myPolicies && loginToken) {
    //         fetchPolicies();
    //     }

    // }, [dispatch, myPolicies, loginToken]);

    useEffect(()=>{
        const fetchPolicies = async () => {
            setLoading(true);
            await dispatch(actionsUser.getMyPolicies());
            setLoading(false);
        }

        fetchPolicies();

    }, [dispatch]);

    const closeModal = () => setConfirmModal({open: false, insuranceId: null})

    const goToDetails = (policy) => onForward(2, null, policy);

    const goBack = () => {
        history.goBack();
    }

    const payInstallment = (event, policy) => {
        event.stopPropagation();
        history.push(`/app/pay-installment/${policy.insuranceId}`);
    }

    const askToDeleteDraft = (event, policy) => {
        event.stopPropagation();

        setConfirmModal({open: true, insuranceId: policy?.insuranceId});
    } 

    const deleteDraft = async (insuranceId) => {
        setConfirmModal({open: false, insuranceId: null})
        setLoading(true);
        await dispatch(actionsPolicy.deleteInsContract(insuranceId));
        await dispatch(actionsUser.getMyPolicies());
        setLoading(false);
    }

    const completePurchase = async (event, policy) => {
        event.stopPropagation();
        const regProps = policy?.registrationProps || {};
        const plate = regProps?.plate?.value;
        const talon = regProps?.ownerCertNo?.value;

        setLoading(true);

        if(Object.keys(regProps).length) {
            
            await dispatch(actionsPolicy.updateRegProps(policy?.registrationProps));
            if(plate && talon) {

                await Promise.all([
                    dispatch(actionsPolicy.updateInitialData({plate, talon, registered: true})),
                    dispatch(actionsPolicy.getLocation(plate)),
                ])
            }
        }

        if(policy?.insuranceDocuments?.length) {
            const talonDoc  = policy?.insuranceDocuments.find(doc => doc.docType === 'TALON')

            await dispatch(actionsPolicy.fetchTalonPicture(talonDoc.fileUploadId, talonDoc.contentType));
        }

        const questions = policy?.questions || {};
        if(Object.keys(questions).length) {
            
            await dispatch(actionsPolicy.updateQuestionsPolicy(questions));
        }

        await Promise.all([
            dispatch(actionsPolicy.getInsCompanies()),
            dispatch(actionsPolicy.setStepLiability(2)),
        ])        

        await dispatch(actionsPolicy.updateRevisedOffer(policy?.insuranceId, policy?.insCompany));
        history.push('/app/new-policy-liability');

    }

    const generatePolicyStatusBg = (policy) => {
        if(!policy) return;
        const status = policy?.status;
       // const status = "ACTIVE";
        const isNotAllPaid = policy?.cashflows?.find(obj=>!obj.paid);
    
        const generateMsgForNotAllPaid = () => {
            const lastPaidCashFlow = findLastPaidOrConDCashFlow(policy?.cashflows);
            const daysPastDueDate = countDaysPastDueDate(policy?.cashflows);

            const text = `${daysPastDueDate} ${daysPastDueDate > 1 ? 'дни' : 'ден'} до вноска`;

            if(daysPastDueDate === null) {
                return <p className="green">Активна</p>
            }
            
            if(lastPaidCashFlow?.cashflowId === 1 && !lastPaidCashFlow?.paid) {
                if(daysPastDueDate <= 0) {
                    if (daysPastDueDate < -15) {
                        return <p className="red">Прекратена</p>
                    } else if(lastPaidCashFlow?.status === 'CASH_ON_DELIVERY') {
                        return <><p className="purple">Активна от</p>
                        <p className="purple">{moment(policy.commenceDate).format('LL')}</p>
                        <p className="purple bold">Очаква плащане</p>
                        </>
                    } 
                } else if (lastPaidCashFlow?.status === 'CASH_ON_DELIVERY') {
                    return <><p className="purple">Активна от</p>
                    <p className="purple">{moment(policy.commenceDate).format('LL')}</p>
                    <p className="purple bold">Очаква плащане</p>
                    </>
                }
            }
            
            if(lastPaidCashFlow?.cashflowId < lastPaidCashFlow?.totalCashflows) {
                if(!lastPaidCashFlow.paid) {
                    if (daysPastDueDate < -15) {
                        return <p className="red">Прекратена</p>
                    } else if(isPolicyAdded(policy) && isBeforeFirstCashflow(policy)) {
                        const days = daysToFirstCashFlow(policy);
                        const text = `${days} ${days > 1 ? 'дни' : 'ден'} до вноска`;

                        return  <><p className="green" style={{flex:1}}>Добавена</p>
                                  <p className="purple bold" style={{flex:1}}>{text}</p>
                                  <button className="nuIns-btn nuIns-btn-main-my-policy" type="submit" 
                                          onClick={(event)=>payInstallment(event, policy)} >Плащане на вноска</button>
                                </>
                    } else {
                        return  <><p className="red" style={{flex:1}}>Просрочена</p>
                                  <button className="nuIns-btn nuIns-btn-main-my-policy" type="submit" 
                                          onClick={(event)=>payInstallment(event, policy)} >Плащане на вноска</button>
                                </>
                    }
                }

                const nextCashFlow = policy?.cashflows.find(obj=>obj.cashflowId === (lastPaidCashFlow?.cashflowId +1));

                if(daysPastDueDate === 0) {
                    return <> <p className="green">Платена до</p>
                              <p className="green">{moment(nextCashFlow.dueDate).format('LL')}</p>
                              <p className="purple bold" style={{flex:1}}>Днес е падежът</p>
                              <button className="nuIns-btn nuIns-btn-main-my-policy" type="submit" 
                                      onClick={(event)=>payInstallment(event, policy)} >Плащане на вноска</button>
                        </>
                } 
                if(daysPastDueDate > 0) {
                   return  <><p className="green">Платена до</p>
                             <p className="green">{moment(nextCashFlow.dueDate).format('LL')}</p>
                             <p className="purple bold" style={{flex:1}}>{text}</p>
                             <button className="nuIns-btn nuIns-btn-main-my-policy" type="submit" 
                                     onClick={(event)=>payInstallment(event, policy)} >Плащане на вноска</button>
                        </>
                } else if(daysPastDueDate < 0) {
                    return <p className="red">Просрочена</p>
                }
            } else if(lastPaidCashFlow?.cashflowId === lastPaidCashFlow?.totalCashflows) {
                if(daysPastDueDate >= 0) {
                    return <><p className="green">Платена до</p>
                             <p className="green">{moment(lastPaidCashFlow?.dueDate).format('LL')}</p>
                             <p className="purple bold" style={{flex:1}}>{daysPastDueDate === 0 ? 'Днес е падежът' : text}</p>
                             <button className="nuIns-btn nuIns-btn-main-my-policy" type="submit" 
                                     onClick={(event)=>payInstallment(event, policy)} >Плащане на вноска</button>
                        </>
                } else if(daysPastDueDate < 0) {
                    return daysPastDueDate < -15 
                            ? <p className="red">Прекратена</p> 
                            : <><p className="red" style={{flex:1}}>Просрочена</p>
                                <button className="nuIns-btn nuIns-btn-main-my-policy" type="submit" 
                                        onClick={(event)=>payInstallment(event, policy)} >Плащане на вноска</button>
                            </>
                }
            }
        }

        const generateMsgForFuture = () => {
                return <><p className="purple">Активна от</p>
                         <p className="purple">{moment(policy.commenceDate).format('LL')}</p>
                         {policy?.statusInternal === "READY_FOR_BO_PROCESSING"
                            ? <p className="purple bold">Очаква плащане</p>
                            : null
                         }
                    </>
        }

        const generateMsgForDraft = (policy) => {
            const otherActivePolicy = findOtherActivePolicy(policy, myPolicies);
            if(otherActivePolicy) {
                if(isOtherActivePolicyStopsNew(policy, myPolicies)) {
                    const daysDIff = moment(otherActivePolicy?.expireDate).utc().diff(moment().utc(), 'days');
                    const availableDate = moment().add((daysDIff-15), 'd').format('LL');

                    return <>
                        <p className="purple">Можеш да сключиш нова</p>
                        <p className="purple">полица след</p>
                        <p className="purple" style={{flex:1}}>{availableDate}</p>
                        <button className="nuIns-btn nuIns-btn-main-my-policy" type="submit" disabled
                                         >Завърши покупка</button>
                    </>
                }

                return <><p className="purple">Вече можеш да сключиш</p>
                         <p className="purple" style={{flex:1}}>нова полица</p> 
                         <button className="nuIns-btn nuIns-btn-main-my-policy" type="submit" 
                                        onClick={(event)=>completePurchase(event, policy)} >Завърши покупка</button>
                         </>
            }

            return <><p className="purple" style={{flex:1}}>Незавършена покупка</p>
                    <button className="nuIns-btn nuIns-btn-main-my-policy" type="submit" 
                    onClick={(event)=>completePurchase(event, policy)} >Завърши покупка</button>
        </>
        }

        if(isPolicyExpired(policy)) return <p className="red">Изтекла</p>
    
        switch(status) {
            case 'DRAFT':
                return generateMsgForDraft(policy);
            case 'PROCESSING':
                return <><p className="purple">Полицата е в процес</p>
                         <p className="purple">на обработка</p></>
            case 'ACTIVE':                 
                    return !isNotAllPaid 
                            ? <p className="green">Активна</p>
                            : generateMsgForNotAllPaid();

            case 'FINALIZED':
                return <p className="red">Изтекла</p>
            case 'CANCELED':
                return <p className="red">Прекратена</p>
            case 'VOID':
                return <p className="red">Анулирана</p>
            case 'FUTURE':
                return generateMsgForFuture();
      
                        
            default:
                return ''
        }
    }

    const generateAttentionMsg = (policy) => {
        if(policy.status === 'ACTIVE') {
            const daysPastDueDate = countDaysPastDueDate(policy?.cashflows);
            //const daysPastDueDate = 0;

            const dateToCancel = moment().add(Math.abs(daysPastDueDate), "d").format('LL');

            if(daysPastDueDate && daysPastDueDate <= 0 && daysPastDueDate > -15) {
                return daysPastDueDate === 0
                    ? <p className="red">Полицата ще бъде прекратена днес в 23:59 ч.</p>
                    : daysPastDueDate === -1 
                    ? <p className="red">Полицата ще бъде прекратена утре</p>
                    : <p className="red">{`Полицата ще бъде прекратена на ${dateToCancel}`}</p>
            }
        }

        return null;
    }

    const renderPolicies = () => {
        moment.locale('bg');
        if(!myPolicies) return;
        return myPolicies.map((policy, i)=>{
           // const contractDate = policy?.contractDate ? moment(policy?.contractDate).format('LL') : null;
            const expireDate = policy?.expireDate ? moment(policy?.expireDate).format('LL') : null;
            const {make, model, plate} = getRegValues(policy?.registrationProps);
            const CompanyLogo   = InsCompLogos[policy?.insCompany] ? InsCompLogos[policy?.insCompany]() : null;          

            return <div className="my-policies" key={i+1} style={{cursor: 'pointer'}} onClick={() => goToDetails(policy)}>
                <div className="first-row" >
                    <h6>Гражданска отговорност</h6>
                    <div className="right">
                        {policy?.status === 'DRAFT' 
                        ? <h6>Заявка за полица</h6>
                        : <p>{ expireDate }</p>}
                    </div>
                </div>
                <div className="second-row">
                    <div className="left">
                        <p>{make} {model}</p>
                        <p style={{marginBottom: '.8rem', flex: 1}}>{plate}</p>
                        {policy?.status === 'DRAFT' 
                        ? <button className="nuIns-btn nuIns-btn-outlined-my-policy" type="submit" 
                                    onClick={(event)=>askToDeleteDraft(event, policy)} >Изтрий заявката</button>
                        : <>
                            {CompanyLogo}
                            <div className="name">{insCompBgNames[policy?.insCompany]}</div>
                        </>}
                    </div>
                    <div className="right">
                        {generatePolicyStatusBg(policy)}
                    </div>
                </div>
                <div className="third-row">
                    {generateAttentionMsg(policy)}
                </div>
            </div>
        })
    }

    return (<>
        <div className="steps_container green-divider" style={style}>
            <div className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Моите полици</h6>
            </div>
            <Divider style={{marginBottom: 0}}/>
            {renderPolicies()}

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null }
        </div>

        {/* Modal */}
        <Modal size="xs" show={confirmModal.open} onHide={() => closeModal()} className="delivery-modal">
            <Modal.Header>
                <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingBottom: '2rem'}}>
                <p className="no-reg-data" style={{textAlign: 'center'}}>Искаш ли да изтриеш заявката за полица?</p>    
            </Modal.Body>
            <Divider style={{margin: 0}} />
            <Modal.Footer className='delivery-modal-buttons'>
                <Button appearance="subtle" onClick={() => closeModal()} >НЕ</Button>
                <Button appearance="subtle" onClick={() => deleteDraft(confirmModal.insuranceId)} style={{marginLeft: 0}}>Да, изтрий</Button>
            </Modal.Footer>
        </Modal>

        </>
    )    
}

export default MyPolicyList;